
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history/story",
      function () {
        return require("private-next-pages/history/story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/history/story"])
      });
    }
  